module.exports = __webpack_public_path__ + "static/media/ProfessionalValue.643ff8ab.svg";